<script setup lang="ts">
import { computed } from 'vue';

import { useNotifications } from '@/composables';

import ClaimUpdatesList from '../notifications/ClaimUpdatesList.vue';
import CriticalUpdatesList from '../notifications/CriticalUpdatesList.vue';
import TruCard from '../TruCard.vue';

const {
    criticalUpdates,
    claimUpdates,
} = useNotifications();

const hasNotifications = computed(() =>
    criticalUpdates.value.length !== 0 || claimUpdates.value.length !== 0);
</script>

<template>
    <div
        v-if="hasNotifications"
        class="tasks-and-notifications"
    >
        <TruCard>
            <CriticalUpdatesList
                analytics-location="Dashboard"
                enable-show-more
            />
            <ClaimUpdatesList
                analytics-location="Dashboard"
                enable-show-more
            />
        </TruCard>
    </div>
</template>

<style scoped lang="scss">
.tasks-and-notifications {
    .tru-card-body {
        padding: 1rem;
    }

    .no-updates {
        padding: 1.5rem 0 0 2rem;
    }

    .claim-updates-header {
        margin-bottom: 0.25rem;
    }
}
</style>
